import { useFormik } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import "../WebLinkRetailer/box.css";
import { Button } from "react-bootstrap-v5";
import GalleryService from "../../Services/GalleryService";
import CropImageDialog from "../WebLinkRetailer/CropImageDialog";

const AddGallery = ({setAddModal, getGalleryimg}) => {
  const [loader, setLoader] = useState(false);
  const [image, setImage] = useState("");
  const [cropModal, setCropModal] = useState(false);
  const [valimg, setValimg] = useState(false);

  const history = useHistory();

  const formik = useFormik({
    initialValues: {
      retailer_logo: "",
    },

    validationSchema: Yup.object({
      retailer_logo: Yup.string().required("Required"),
    }),

    onSubmit: (values) => {
      let data = new FormData();

      data.append("image", formik.values.retailer_logo);

      setLoader(true);
      GalleryService.addGalleryImage(data)
        .then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            // history.push("/gallery");
            setAddModal(false)
            getGalleryimg()
            setLoader(false);
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });


  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              {image.imageurl && (
                <div className="mb-3 row">
                  <div className="col-12">
                    <div className="box-img ">
                      <div className="retailer-images">
                        <img src={image.imageurl} />
                      </div>
                    </div>

                    {cropModal && (
                      <CropImageDialog
                        cropModal={cropModal}
                        setCropModal={setCropModal}
                        imagedata={image}
                        setNewImage={setImage}
                        setFieldValue={formik.setFieldValue}
                      />
                    )}
                  </div>
                </div>
              )}

              <div className="mb-3 row mt-2">
                <div className="col-12">
                  <input
                    required={false}
                    type="file"
                    className={
                      "form-control" +
                      (formik.touched.retailer_logo
                        ? !formik.errors.retailer_logo
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    onChange={(e) => {
                      if (e.target.files[0].name.split(".").at(-1) === "svg") {
                        setValimg(true);
                      } else {
                        setValimg(false);
                        formik.setFieldValue("retailer_logo", e.target.files[0]);
                        setImage({
                          imageurl: URL.createObjectURL(e.target.files[0]),
                          image: e.target.files,
                        });
                      }
                    }}
                  />
                  {valimg === true && (
                    <p className="text-danger">
                      Uploaded file has unsupported format
                    </p>
                  )}
                  {formik.touched.retailer_logo && formik.errors.retailer_logo ? (
                    <div className="text-danger">
                      {formik.errors.retailer_logo}
                    </div>
                  ) : null}
                </div>
                {
                  image.imageurl &&
                <div className="text-end col-12 mt-3">
                  <Button
                    style={{ width: "95px" }}
                    onClick={() => setCropModal(true)}
                  >
                    crop
                  </Button>
                </div>
                }
              </div>
              {/* </div> */}
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
              {/* <ImageCropper/> */}
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGallery;
